import React from 'react';
import type { Summary } from '../../types/messages';

interface Props {
  text: string;
  summary: Summary;
  includeTax: boolean;
}

const ProposalSummaryMessage = ({ text, summary, includeTax }: Props) => {
  const styles = getStyles();
  const { items, totalPrice, totalPriceWithTax, hasSelection } = summary;

  if (!hasSelection) {
    return (
      <div style={styles.container}>
        <div style={styles.noSelectionMessage}>{text}</div>
      </div>
    );
  }

  const displayTotal = includeTax ? totalPriceWithTax : totalPrice;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.checkIcon}>✓</span>
        <span>すべての商品を選択いただきました</span>
      </div>
      <div style={styles.section}>
        <div style={styles.sectionTitle}>選択内容の確認：</div>
        <div style={styles.itemList}>
          {items.map(item => (
            <div key={item.category} style={styles.item}>
              ・{item.label}：{item.text}
            </div>
          ))}
        </div>
      </div>
      <div style={styles.totalRow}>
        <span style={styles.totalLabel}>合計金額：</span>
        <span style={styles.totalPrice}>
          ¥{displayTotal.toLocaleString()}
          {includeTax ? '（税込）' : ''}
        </span>
      </div>
    </div>
  );
};

const getStyles = () => ({
  container: {
    backgroundColor: '#f0f9f4',
    border: '1px solid #a8d5ba',
    borderLeft: '4px solid #2e7d32',
    borderRadius: '6px',
    padding: '16px',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    gap: '12px',
    maxWidth: '360px'
  },
  header: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: '8px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#2e7d32'
  },
  checkIcon: {
    fontSize: '16px',
    color: '#2e7d32'
  },
  section: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    gap: '8px'
  },
  sectionTitle: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#333'
  },
  itemList: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    gap: '8px'
  },
  item: {
    fontSize: '13px',
    color: '#333'
  },
  totalRow: {
    display: 'flex' as const,
    alignItems: 'baseline' as const,
    gap: '8px',
    paddingTop: '4px'
  },
  totalLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#333'
  },
  totalPrice: {
    fontSize: '13px',
    color: '#333'
  },
  noSelectionMessage: {
    fontSize: '14px',
    color: '#666',
    whiteSpace: 'pre-wrap' as const
  }
});

export default ProposalSummaryMessage;
